module.exports = __webpack_public_path__ + "static/img/DrivingForce_logo_2017_200px2.ef2be22.png";